import React from 'react';

import Banner from '@/components/EditorViewer/BannerWithTitle';
import { useArticle } from '@/modules/corporate/modules/article/articleContext';

import { BannerWithTitleContainerProps } from './types';

const BannerWithTitleContainer: React.FC<BannerWithTitleContainerProps> = (props) => {
  const { bannerRef, progress } = props;

  const {
    articleContent: {
      title,
      cover: { src, yOffsetPercent },
    },
    article: { toAwardPoints, badges },
  } = useArticle();

  return (
    <Banner
      ref={bannerRef}
      alwaysShowBanner
      showPointsAndBadges
      badges={badges}
      points={toAwardPoints ?? undefined}
      progress={progress}
      src={src}
      title={title}
      yOffsetPercent={yOffsetPercent}
    />
  );
};

export default React.memo(BannerWithTitleContainer);
